const SHOW_CLIENT_ID = 'SHOW_CLIENT_ID'

const initialState = {
  name: null,
}

const clientIdReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case SHOW_CLIENT_ID: {
      return {
        ...state,
       id: action.id
      }
    }

    default: {
      return state
    }
  }
}

export default clientIdReducer